<template>
  <div class="login el-reset">
    <el-form
      :model="form"
      :rules="rules"
    >
      <h2 class="el-h2">
        {{ $t('vrlounge.loginToAccount') }}
      </h2>
      <el-form-item prop="username">
        <label
          for="username"
          class="el-label"
        >{{ $t('general.username') }}</label>
        <el-input
          v-model="form.username"
          name="username"
          :placeholder="$t('general.username')"
        />
      </el-form-item>
      <el-form-item prop="password">
        <label
          for="password"
          class="el-label"
        >{{ $t('general.password') }}</label>
        <el-input
          v-model="form.password"
          password
          name="password"
          show-password
          :placeholder="$t('general.password')"
        />
      </el-form-item>
      <div style="text-align: end">
        <a
          class="el-link"
          :href="forgotPasswordUrl"
          target="__blank"
        >{{ $t('general.forgetPassword') }}</a>
      </div>
    </el-form>
    <div class="el-keep-login-row">
      <label
        class="el-checkbox-label"
        for="keeplogin"
      ><input
        id="keeplogin"
        v-model="isKeepLogin"
        type="checkbox"
        class="el-checkbox"
      >{{ $t('vrlounge.keepLogin') }}</label>
    </div>
    <button
      class="el-button"
      :loading="loading"
      @click="handleSubmit"
    >
      {{ $t('general.login') }}
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Message } from 'element-ui'
import webStorage from '../../../store/webStorage/helper'

export default {
  name: 'VrLoungeLogin',
  data () {
    return {
      editorUrl: process.env.EDITOR_URL,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: this.$t('general.required') }],
        password: [{ required: true, min: 6, message: this.$t('general.required') }]
      },
      isKeepLogin: true,
      loading: false,
      isPasswordHintShow: false
    }
  },
  computed: {
    ...mapGetters([
      'currentBuilding',
      'property'
    ]),
    forgotPasswordUrl () {
      const hasProperty = this.property && this.property.objectId
      let redirectUrl = ''
      if (hasProperty) {
        redirectUrl = this.property.meta.viewerRedirectUrl || location.href
      } else {
        redirectUrl = this.currentBuilding.meta.viewerRedirectUrl || location.href
      }
      return `${this.editorUrl}/forgot-pass?redirectUrl=${encodeURIComponent(redirectUrl)}`
    }
  },
  watch: {
    isKeepLogin (val) {
      webStorage.setItem(`keep_login_${process.env.NODE_ENV}`, JSON.stringify(val))
    }
  },
  beforeMount () {
    this.isKeepLogin = JSON.parse(webStorage.getItem(`keep_login_${process.env.NODE_ENV}`) || 'true')
  },
  methods: {
    ...mapActions({
      login: 'auth/login'
    }),
    ...mapActions([
      'closeVisitor'
    ]),
    async handleSubmit () {
      this.loading = true
      try {
        const result = await this.login({
          username: this.form.username,
          password: this.form.password,
          isKeepLogin: this.isKeepLogin
        })
        const profile = {
          name: result.name || '',
          email: String(result.email || result.username).toLowerCase(),
          phone: result.phone || ''
        }
        this.$mixpanel.setPeopleInfo(profile)
        this.$mixpanel.start()
        this.closeVisitor()
        this.$emit('login', result)
      } catch (error) {
        Message({ message: 'Invalid user name or password', type: 'error' })
      } finally {
        this.loading = false
      }
    }
  }

}
</script>
<style lang="stylus" scoped>
@import '~css/addon/main'

.login {
  width: 490px;
  text-align: center
  padding: 24px 20px
  display: flex;
  flex-direction: column
  justify-content: center
  align-items: center
  @media (max-width: $response-xs) {
    padding: 0
    height: 100%
    width: calc(100vw - 40px)
  }

  & > .el-form {
    width: 100%
  }
}
.el-button {
  background-color: $pink-color
  width: 100%
  font-size: 20px
  color: $white
  margin: 8px 0
  border: none
}

.el-h2 {
  font-size: 24px
  margin: 16px 0
  color: $white
}

.el-label {
  display: flex
  color: $pink-color
  text-transform: capitalize
}

.el-link {
  margin-top: -16px
  color: $pink-color
}

.el-checkbox-label {
  margin-top: 16px
  color: $white
  font-size: 14px
}

.el-checkbox {
  width: 24px
  height: 16px
  margin: 0 4px
}

.el-keep-login-row {
  display: flex
  justify-content: left
  align-self: flex-start
}
</style>
